module.exports = __webpack_public_path__ + "img/nastassia_gallace.2ae38afe.png";